export const validationMessage = {
  REQUIRED: "This field is required",
  MINIMUM_CURRENCY_VALUE: "This field should be greater than or equal 0.01",
  MAXIMUM_PERCENTAGE_VALUE: "This field should be less than or equal 100",
  INVALID_IMAGE_FILE: "This is not a valid image file",
}